import CallToAction from '../components/CallToAction'
import '../styles/landing.css'

export default function Hero() {
  return (
    <section id="hero">
      <div className="hero-container">

        {/* Titulo a todo lo ancho */}
        <h2 className="hero-title">
          Lleva tus estudios a un nivel superior con Ascensos App Vortex.
        </h2>

        {/* Fila: texto + logo */}
        <div style={{ textAlign: 'justify' }} className="hero-row">
          <p className="hero-text">
            Un sistema integral de educación en la palma de tu mano, para estudiar
            leyendo, escuchando, interactuando, creando tus propios recursos para ese ascenso
            que tanto deseas, ya sea por promoción normal, por adecuación o por pase a la milicia
            permanente — Ascensos App está para ayudarte.
          </p>

          {/* Visual */}
          <div className="hero-visual">
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <img
                src="/icons/logo.png"
                alt="AscensosApp Vortex"
                className="hero-logo"
              />
              <div className="hero-float hero-float-top">
                <img src="/icons/helm.gif" style={{ width: '50px' }} alt="Timón" />
              </div>
              <div className="hero-float hero-float-bot">
                <img src="/icons/compass.gif" style={{ width: '38px' }} alt="Brújula" />
              </div>
            </div>
          </div>
        </div>

        {/* Botones */}
        <CallToAction />

      </div>
    </section>
  )
}